var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 60,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "4.0 2.0 56.0 60.0",
    width: 56,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "a",
    x1: -0.89,
    x2: 64.849,
    xlinkActuate: "onLoad",
    xlinkShow: "other",
    xlinkType: "simple",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y1: 0.284,
    y2: 63.675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#90278e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#35aad7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32,21c-6.065,0-11,4.935-11,11s4.935,11,11,11s11-4.935,11-11S38.065,21,32,21z M32,41 c-4.962,0-9-4.037-9-9s4.038-9,9-9s9,4.037,9,9S36.962,41,32,41z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "b",
    x1: -0.89,
    x2: 64.849,
    xlinkActuate: "onLoad",
    xlinkShow: "other",
    xlinkType: "simple",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y1: 0.284,
    y2: 63.675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#90278e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#35aad7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.515,28.143l-5-3c-0.317-0.189-0.712-0.189-1.029,0l-5,3C26.184,28.323,26,28.648,26,29v6 c0,0.352,0.184,0.677,0.485,0.857l5,3C31.644,38.952,31.822,39,32,39s0.356-0.048,0.515-0.143l5-3C37.816,35.677,38,35.352,38,35 v-6C38,28.648,37.816,28.323,37.515,28.143z M32,27.166L35.056,29L32,30.834L28.944,29L32,27.166z M28,30.766l3,1.8v3.667l-3-1.8 V30.766z M33,36.234v-3.667l3-1.8v3.667L33,36.234z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "c",
    x1: -0.89,
    x2: 64.849,
    xlinkActuate: "onLoad",
    xlinkShow: "other",
    xlinkType: "simple",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y1: 0.284,
    y2: 63.675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#90278e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#35aad7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.515,23.857C59.816,23.677,60,23.352,60,23v-5c0-0.352-0.184-0.677-0.485-0.857l-5-3 c-0.317-0.189-0.712-0.189-1.029,0l-4.492,2.695L38,10.425V6c0-0.352-0.184-0.677-0.485-0.857l-5-3 c-0.317-0.189-0.712-0.189-1.029,0l-5,3C26.184,5.323,26,5.648,26,6v4.425l-10.993,6.413l-4.492-2.695 c-0.317-0.189-0.712-0.189-1.029,0l-5,3C4.184,17.323,4,17.648,4,18v5c0,0.352,0.184,0.677,0.485,0.857L9,26.566v10.868 l-4.515,2.709C4.184,40.323,4,40.648,4,41v5c0,0.352,0.184,0.677,0.485,0.857l5,3C9.644,49.952,9.822,50,10,50 s0.356-0.048,0.515-0.143l4.492-2.695L26,53.575V58c0,0.352,0.184,0.677,0.485,0.857l5,3C31.644,61.952,31.822,62,32,62 s0.356-0.048,0.515-0.143l5-3C37.816,58.677,38,58.352,38,58v-4.425l10.993-6.413l4.492,2.695C53.644,49.952,53.822,50,54,50 s0.356-0.048,0.515-0.143l5-3C59.816,46.677,60,46.352,60,46v-5c0-0.352-0.184-0.677-0.485-0.857L55,37.434V26.566L59.515,23.857z M26.993,12.162L31,14.566v2.484c-5.07,0.337-9.449,3.195-11.903,7.338L16,22.446v-3.871L26.993,12.162z M48,18.575v3.87 l-3.103,1.934c-2.454-4.138-6.831-6.992-11.897-7.329v-2.484l4.007-2.404L48,18.575z M53,37.434l-3.988,2.393l-3.19-2 C46.58,36.034,47,34.065,47,32c0-2.07-0.421-4.042-1.183-5.838l3.193-1.99L53,26.566V37.434z M32,54.834L28.944,53L32,51.166 L35.056,53L32,54.834z M32,45c-7.168,0-13-5.832-13-13s5.832-13,13-13s13,5.832,13,13S39.168,45,32,45z M14.988,39.827L11,37.434 V26.566l3.988-2.393l3.19,2C17.42,27.966,17,29.935,17,32c0,2.065,0.42,4.034,1.178,5.827L14.988,39.827z M11,21.566l3-1.8v2.667 l-3,1.8V21.566z M50,19.766l3,1.8v2.667l-3-1.8V19.766z M36,10.434l-3,1.8V9.566l3-1.8V10.434z M31,9.566v2.667l-3-1.8V7.766 L31,9.566z M13.056,41L10,42.834L6.944,41L10,39.166L13.056,41z M16,41.554l3.097-1.942c2.453,4.142,6.833,7.001,11.903,7.338 v2.484l-4.007,2.404L16,45.425V41.554z M37.007,51.838L33,49.434v-2.484c5.07-0.337,9.449-3.195,11.903-7.338L48,41.554v3.871 L37.007,51.838z M54,42.834L50.944,41L54,39.166L57.056,41L54,42.834z M55,24.234v-2.667l3-1.8v2.667L55,24.234z M54,16.166 L57.056,18L54,19.834L50.944,18L54,16.166z M32,4.166L35.056,6L32,7.834L28.944,6L32,4.166z M10,16.166L13.056,18L10,19.834 L6.944,18L10,16.166z M6,19.766l3,1.8v2.667l-3-1.8V19.766z M6,42.766l3,1.8v2.667l-3-1.8V42.766z M11,47.234v-2.667l3-1.8v2.667 L11,47.234z M28,54.766l3,1.8v2.667l-3-1.8V54.766z M33,59.234v-2.667l3-1.8v2.667L33,59.234z M50,42.766l3,1.8v2.667l-3-1.8 V42.766z M55,47.234v-2.667l3-1.8v2.667L55,47.234z",
    fill: "url(#c)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockBg);
export default __webpack_public_path__ + "static/media/block-bg.e2597729b5eb87736a67c8d3b40a66b5.svg";
export { ForwardRef as ReactComponent };